module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product9-1351101c31b17c0c41b2b644d7bf6754.jpg";